
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../../controlador';
    import seguimiento from './resumen-menu-procesos-seguimiento-envio.vue';
    import facturar from './resumen-menu-procesos-facturar.vue';
    import descargar from './resumen-menu-procesos-descargar.vue';
    import remitos from './resumen-menu-procesos-remitos.vue';
    import sicronizar from './resumen-menu-procesos-sincronizar.vue';
    import editar from './resumen-menu-procesos-editar.vue';
    import pagoensucursal from './resumen-menu-procesos-pago-en-sucursal.vue';
    import buscarenvio from './resumen-menu-procesos-buscar-envios.vue';
    import entregar from './resumen-menu-procesos-entregar.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            pagoensucursal,
            buscarenvio,
            seguimiento,
            facturar,
            remitos,
            descargar,
            editar,
            sicronizar,
            entregar ,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }


        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'procesos' )
                {
                    this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 300;
                }
            } ) );

            this.SubModo = 'procesos';
            this.Iniciar();
        }


        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            this.Cargando = true;

            this.Cargando = false;
        }

        public async Abrir( item: string )
        {
            this.Modo = item;
        }


        Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
